import React from 'react';
import { getScoreDisplayValue, getScorePosition } from '../../../pages/cardiology/utils';
import './Score.scss';

const Score = ({ score }: {
    score: number | string;
}) => {
    const scoreToDisplay = Math.max(Math.min((
        parseFloat(score + '') || 0
    ), 100), 0);

    return (
        <div className="scoreWidget">
            <div className="scoreWidget_content">
                <div className="scoreWidget_content_scoreTitle">
                    Probability of Coronary Artery Disease:
                </div>
                <div className="scoreWidget_content_scoreSection">
                    <div className="scoreWidget_content_scoreSection_left">
                        <div className="scoreWidget_content_scoreSection_left_content">
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    <div
                                        className="scoreWidget_content_scoreSection_left_content_score">
                                        {getScoreDisplayValue(scoreToDisplay)}
                                    </div>
                                    <div
                                        className="scoreWidget_content_scoreSection_left_content_scoreDescription">
                                        Clinic + CCS Model
                                    </div>
                                </div>
                            </div>
                            <div
                                className="scoreWidget_content_scoreSection_left_content_scoreDescription2">
                                {
                                scoreToDisplay > 0 && scoreToDisplay < 15 ? (<> <b>Low</b> pre-test probability of coronary artery disease.</> )
                                : scoreToDisplay > 15 && scoreToDisplay < 50 ? (<><b>Intermediate</b> pre-test probability of coronary artery disease.</>)
                                : scoreToDisplay > 50 && scoreToDisplay < 85 ? (<><b>High</b> pre-test probability of coronary artery disease.</>)
                                : scoreToDisplay > 85 && scoreToDisplay < 100? (<><b>Very High</b> pre-test probability of coronary artery disease. </>)
                                : null
                            }
                                
                            </div>
                        </div>
                    </div>
                    <div className="scoreWidget_content_scoreSection_right">
                        <div className="score-rectangle">
                            <div className="high">High</div>
                            <div className="med">Med</div>
                            <div className="low">Low</div>
                            <div className="zero"/>
                            <div
                                className="yourRisk"
                                style={{
                                    top: `calc(${getScorePosition(scoreToDisplay)}% - 4px)`,
                                }}
                            >
                                <div className="rect"/>
                                ← Your Risk
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Score;